export function StatCard({ label, value, sub, className = '' }) {
  return (
    <div className={`rounded-xl border border-border bg-card p-4 shadow-card ${className}`}>
      <p className="label-wrap text-xs font-medium leading-snug text-muted">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-text">{value}</p>
      {sub && <p className="mt-0.5 text-sm text-muted">{sub}</p>}
    </div>
  );
}
